// Vue
import { Component, Vue } from "vue-property-decorator";
// Mobx
import { autorun } from "mobx";
import { Observer } from "mobx-vue";
// Template
import template from "./template.vue";
// Enums

import "#/modules/index.ts";
import { User } from "@mgs/ci2019-common/src/models/user/User";
import { IRegion } from "@mgs/ci2019-common/src/interfaces/IRegion";
import { Api } from "#/api";

@Observer
@Component({
  mixins: [template],
  components: {},
})
export class LoadingLayout extends Vue {
  get headerAuthOptions() {
    return new User({
      is_logged_in: false,
      login_url: "",
    });
  }

  public handleBodyPaddingChanged(padding: number) {
    this.$store.ui.bodyPadding = padding;
  }
}
